<template>
  <div>
    <nav class="m-header" v-if="countryLoaded || isAuthenticated">
      <router-link to="/catalogo" v-show="showCatalogLink">
        <div class="m-header__item">
        <span class="button button--light">
          {{ $t("header.catalog", headerLang) }}
        </span>
        </div>
      </router-link>


      <!-- <a href="/blog/categorias/listas-de-ejemplo">
        <span style="display: block;" class="m-header__item">
          <span
              class="button button--light"
          >Listas de ejemplo</span
          >
        </span>
      </a> -->

      <!-- <a href="/programa-de-recompensas" v-if="featureEcommerceAvailable && headerLang != 'fr-FR' && headerLang != 'it-IT'">
        <span style="display: block;" class="m-header__item">
          <span
              class="button button--light"
          >{{ $t("header.rewardsProgram", headerLang) }}</span
          >
        </span>
      </a> -->

      <a :href="$t('routes.hucha-de-nacimiento', headerLang)" v-if="!isAuthenticated && !hidePiggyBank">
        <span class="m-header__item">
          <span
              class="button button--light"
          >{{ $t("header.contributions", headerLang) }}</span
          >
        </span>
      </a>
      <router-link v-else-if="!hidePiggyBank && !hasContributionMethods && contributionsFlag" to="/mi-hucha/crear">
        <div class="m-header__item">
        <span class="button button--light">
          {{ $t("header.contributions", headerLang) }}
        </span>
        </div>
      </router-link>
      <!-- Blog can't be showed -->
      <a href="/blog" v-show="showBlogLink">
        <span style="display: block;" class="m-header__item">
          <!-- <router-link to="/blog" class="button button--light">Blog</router-link> --> <!-- Force SSR -->
          <span class="button button--light"
          >{{ $t("header.blog", headerLang) }}</span
          >
        </span>
      </a>
    </nav>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import Features from "../../Mixins/Features";

export default {
  name: "HeaderNav",
  mixins: [
    Features,
  ],
  props: {
    headerLang: {
      type: String,
      default: "es-ES",
    },
    headerType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      countryLoaded: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      list: "ownerList",
      isAuthenticated: "isAuthenticated",
      contributionsFlag: "contributionsFlag",
      hidePiggyBank: "hidePiggyBank",
      isInternational: "isInternational",
    }),
    stripeAccountId() {
      return this.user?.stripeAccountId || "";
    },
    hasContributionMethods() {
      return this.user?.contributionMethods?.length > 0;
    },
    showBlogLink() {
      try {
        return this.featureBlogAvailable &&
          this.headerLang !== 'fr-FR' &&
          this.headerLang !== 'it-IT' &&
          this.headerLang !== 'en-GB' &&
          this.headerLang !== 'de-DE' &&
          this.headerLang !== 'nl-NL' &&
          this.headerLang !== 'pt-BR' &&
          (
              (!this.isAuthenticated && this.headerType === 'baby') ||
              (this.isAuthenticated && this.list?.type === 'baby-registry')
          );
      } catch (error) {
        return true;
      }
    },
    showCatalogLink() {
      try {
        return this.featureCatalogAvailable &&
          this.headerLang !== 'fr-FR' &&
          this.headerLang !== 'it-IT' &&
          this.headerLang !== 'en-GB' &&
          this.headerLang !== 'de-DE' &&
          this.headerLang !== 'nl-NL' &&
          this.headerLang !== 'pt-BR' &&
          (
              (!this.isAuthenticated && this.headerType === 'baby') ||
              (this.isAuthenticated && this.list?.type === 'baby-registry')
          );
      } catch (error) {
        return true;
      }
    },
  },
};
</script>
